module.exports = __webpack_public_path__ + "img/imagen_parrafo_4.bfd78b55.jpg";